// tslint:disable
export enum DocumentStatus {
    /**
     * @description UNPROCESSED
     */
    UNKN = 0,
    /**
     * @description LOADED
     */
    LOAD = 1,
    /**
     * @description PENDING
     */
    PEND = 2,
    /**
     * @description MISSING INFORMATION
     */
    MISSINFO = 3,
    /**
     * @description PROCESSED
     */
    PRCSED = 4,
    /**
     * @description UN ASSIGNED
     */
    UNASGN = 5,
    /**
     * @description NOT READABLE
     */
    NOTRD = 6,
    /**
     * @description SKIPPED
     */
    SKIP = 7,
    /**
     * @description EXPIRED
     */
    EXP = 8,
    /**
     * @description Sent
     */
    Sent = 9,
    /**
     * @description VOID
     */
    Void = 10,
    /**
     * @description Submitted
     */
    Submit = 11,
    /**
     * @description Successful
     */
    Success = 12,
    /**
     * @description Failure
     */
    Failure = 13,
    /**
     * @description Opened
     */
    Open = 14,
    /**
     * @description Requested
     */
    Requested = 15,
    /**
     * @description Print Successful
     */
    Printed = 16,
    /**
     * @description Document Print Failed
     */
    PrintFailed = 17,
    /**
     * @description Document Needs Review
     */
    NeedsReview = 18,
    /**
     * @description Document Under Review
     */
    UnderReview = 19,
    /**
     * @description Document Review Rejected
     */
    DocumentRejected = 20,
    /**
     * @description Document Approved
     */
    DocumentApproved = 21,
    /**
     * @description SMS Sucessful
     */
    SMSSucessfull = 22,
    /**
     * @description SMS Failure
     */
    SMSFailure = 23,
    /**
     * @description Print Queued
     */
    PrintQueued = 24,
    /**
     * @description Resent
     */
    Resent = 25,
    /**
     * @description Returned
     */
    Returned = 26,
    /**
     * @description Acknowledged
     */
    Acknowledged = 27,
    /**
     * @description Damaged/Destroyed
     */
    Damaged = 28,
    /**
     * @description Unverified Address
     */
    UnverifiedAddress = 29,
}
(DocumentStatus as any)['SENT'] = 9;
(DocumentStatus as any)['VOID'] = 10;
(DocumentStatus as any)['SUBMIT'] = 11;
(DocumentStatus as any)['SUCCESS'] = 12;
(DocumentStatus as any)['FAILURE'] = 13;
(DocumentStatus as any)['OPEN'] = 14;
(DocumentStatus as any)['REQUESTED'] = 15;
(DocumentStatus as any)['PRINTED'] = 16;
(DocumentStatus as any)['PRINTFAILED'] = 17;
(DocumentStatus as any)['NEEDSREVIEW'] = 18;
(DocumentStatus as any)['UNDERREVIEW'] = 19;
(DocumentStatus as any)['DOCUMENTREJECTED'] = 20;
(DocumentStatus as any)['DOCUMENTAPPROVED'] = 21;
(DocumentStatus as any)['SMSSUCESSFULL'] = 22;
(DocumentStatus as any)['SMSFAILURE'] = 23;
(DocumentStatus as any)['PRINTQUEUED'] = 24;
(DocumentStatus as any)['RESENT'] = 25;
(DocumentStatus as any)['RETURNED'] = 26;
(DocumentStatus as any)['ACKNOWLEDGED'] = 27;
(DocumentStatus as any)['DAMAGED'] = 28;
(DocumentStatus as any)['UNVERIFIEDADDRESS'] = 29;
